<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      {{ dataModal.dataItem.is_expense === '1'? 'Gider Tanımı' : 'Gelir Tanımı' }}
    </div>
    <template v-if="dataModal.dataItem.donation_group">
      <div>{{ dataModal.dataItem.donation_group }}</div>
      <div class="text-warning font-small-2">
        {{ dataModal.dataItem.main_group }}
      </div>
      <b-badge
        variant="light-warning"
      >
        {{ dataModal.dataItem.donation_type }}
      </b-badge>
    </template>
    <template v-else>
      <div class="text-muted">
        Belirtilmedi
      </div>
    </template>
  </b-list-group-item>
</template>
<script>
import { BBadge, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonationGroup',
  components: {
    BBadge,
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
  },
}
</script>
